import Vue from 'vue'
import Router from 'vue-router'
import Layout from 'views/firmiana/layout'

const _import = require('./_import_' + process.env.NODE_ENV)

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export const adminRouterMap = [
  // admin router
  {
    path: '/admin',
    redirect: '/admin/dashborad', // 重定向再加一级
    component: _import('firmiana/admin/index'),
    name: 'appAdmin',
    meta: {icon: 'fa fa-home fa-fw', title: 'Dashborad', noCache: false, roles: ['User'], admin: true},
    children: [
      {
        path: 'dashborad',
        name: 'appDashBoard',
        // meta: {icon: 'fa fa-home fa-fw', title: 'Dashborad', noCache: false, roles: ['Director']},
        meta: {icon: 'fa fa-home fa-fw', title: 'Dashborad', noCache: false, admin: true},
        component: _import('firmiana/admin/dashboard')
      }
    ]
  },
  {
    path: '/lab',
    component: _import('firmiana/admin/index'),
    redirect: '/lab/labList',
    name: 'appLab',
    meta: {icon: 'fa fa-flask fa-fw', title: 'Labs', noCache: false, admin: true},
    children: [
      {
        path: 'labList',
        name: 'appLablist',
        meta: {icon: 'fa fa-list fa-fw', title: 'Lab', noCache: false, admin: true},
        component: _import('firmiana/admin/labs/index')
      },
      {
        path: 'members',
        name: 'appLabMembers',
        meta: {icon: 'fa fa-users fa-fw', title: 'Members', noCache: false, admin: true},
        component: _import('firmiana/admin/labs/members'),
        hidden: true
      },
      {
        path: 'newLab',
        name: 'appNewLab',
        component: _import('firmiana/admin/labs/newLab/index'),
        meta: {icon: 'fa fa-users fa-fw', title: 'New Lab', noCache: false, admin: true},
        hidden: true
      },
      {
        path: 'modifyLab',
        name: 'appModifyLab',
        component: _import('firmiana/admin/labs/newLab/modify'),
        meta: {icon: 'fa fa-users fa-fw', title: 'Modify Lab', noCache: false, admin: true},
        hidden: true
      },
      {
        path: 'organization',
        name: 'appOrganization',
        meta: {icon: 'fa fa-users fa-fw', title: 'organization', noCache: false, admin: true},
        // component: _import('labList/newLab/organization'),
        hidden: true
      }
    ]
  },
  // {
  //   path: '/projectmemebers',
  //   component: _import('firmiana/admin/index'),
  //   redirect: '/projectmemebers/projectList',
  //   name: 'appProjectMembers',
  //   meta: {icon: 'fa fa-flask fa-fw', title: 'Project Members Setting', noCache: false, admin: true},
  //   children: [
  //     {
  //       path: 'projectList',
  //       name: 'appProjectMembersList',
  //       meta: {icon: 'fa fa-list fa-fw', title: 'Project Members Setting', noCache: false, admin: true},
  //       component: _import('firmiana/admin/project/index')
  //     },
  //     {
  //       path: 'modifyProject',
  //       name: 'appnewProjectModify',
  //       meta: {icon: '', hidden: true, title: 'Modify Projects', noCache: false, roles: ['User'], admin: true},
  //       component: _import('firmiana/project/create/project/modifyPro'),
  //       hidden: true
  //     },
  //     {
  //       path: 'projectmembersedit',
  //       name: 'appProjectMembersEdit',
  //       hidden: true,
  //       meta: {icon: 'fa fa-list fa-fw', title: 'Project Members Edit', noCache: false, admin: true},
  //       component: _import('firmiana/admin/project/rolesSet')
  //     }
  //   ]
  // },
  // 功能未健全
  // {
  //   path: '/rolesPrivilege',
  //   component: _import('firmiana/admin/index'),
  //   name: 'appRoles',
  //   redirect: '/rolesPrivilege/roles',
  //   meta: {icon: 'fa fa-user-plus fa-fw', title: 'Roles Privilege', roles: ['PI'], admin: true},
  //   children: [
  //     {
  //       path: 'roles',
  //       name: 'appRolesList',
  //       meta: {icon: 'fa fa-user fa-fw', title: 'Roles', noCache: false, roles: ['PI'], admin: true},
  //       component: _import('firmiana/admin/roles/roles')
  //     }
  //   ]
  // },
  {
    path: '/users',
    component: _import('firmiana/admin/index'),
    redirect: '/users/personalSettings',
    name: 'appUsers',
    meta: {icon: 'fa fa-users fa-fw', title: 'Users', admin: true},
    children: [
      // {
      //   path: 'userList',
      //   name: 'appUserList',
      //   meta: {icon: 'fa fa-list fa-fw', title: 'User List', noCache: false, roles: ['Director']},
      //   component: _import('firmiana/admin/users/userList')
      // },
      // {
      //   path: 'friends',
      //   name: 'appFriends',
      //   meta: {icon: 'fa fa-address-book fa-fw', title: 'Friends', noCache: false, roles: ['Director']}
      //   // component: _import('users/friends')
      // },
      // {
      //   path: 'myInvitation',
      //   name: 'appMyinvitation',
      //   meta: {icon: 'fa fa-user-plus fa-fw', title: 'My Invitation', noCache: false, admin: true},
      //   component: _import('firmiana/admin/users/myInvitation')
      // }
      {
        path: 'personalSettings',
        name: 'appPersonalsettings',
        meta: {icon: 'fa fa-cog fa-fw', title: 'Personal Settings', noCache: false, admin: true},
        component: _import('firmiana/admin/users/personalSetting')
      }
    ]
  },
  {
    path: '/auditCenter',
    component: _import('firmiana/admin/index'),
    redirect: '/auditCenter/labAudit',
    name: 'appAuditCenter',
    meta: {icon: 'fa fa-file', title: 'Audit Center', admin: true},
    children: [
      {
        path: 'labAudit',
        name: 'appLabaudit',
        meta: {icon: 'fa fa-flask', title: 'Lab Audit', noCache: false, roles: ['PI'], admin: true},
        component: _import('firmiana/admin/audit/labList')
      },
      // {
      //   path: 'labmemebersaudit',
      //   name: 'appLabModifyStatus',
      //   meta: {icon: 'fa fa-flask', title: 'Audit Members', noCache: false, roles: ['Director']},
      //   component: _import('firmiana/admin/audit/modifyStatus')
      // }
      // {
      //   path: 'projectAudit',
      //   name: 'appProjectaudit',
      //   meta: {icon: 'fa fa-sitemap', title: 'Project Audit', noCache: false, roles: ['']}
      //   // component: _import('auditcenter/projectaudit')
      // },
      {
        path: 'labMemberaudit',
        name: 'appLabmemberaudit',
        meta: {icon: 'fa fa-users', title: 'Lab Member Audit', noCache: true, roles: ['User'], admin: true},
        component: _import('firmiana/admin/audit/labMembersAudit')
      }
      // {
      //   path: 'projectMemberaudit',
      //   name: 'appProjectmemberaudit',
      //   meta: {icon: 'fa fa-users', title: 'Project Member Audit', noCache: false, roles: ['User']}
      //   // component: _import('firmiana/admin/audit/projectMem')
      // },
      // {
      //   path: 'dataAudit',
      //   name: 'appDataaudit ',
      //   meta: {icon: 'fa fa-database', title: 'Data Audit', noCache: false, roles: ['User']}
      //   // component: _import('auditcenter/dataaudit')
      // }
    ]
  },
  {
    path: '/cvEdit',
    component: _import('firmiana/admin/index'),
    redirect: '/cvEdit/index',
    name: 'appCvEdit1',
    meta: {icon: 'fa fa-file', title: 'CV Edit', roles: ['PI']},
    children: [
      {
        path: 'index',
        name: 'appCvEdit',
        meta: {icon: 'fa fa-flask', title: 'CV Edit', noCache: false, roles: ['PI'], admin: true},
        component: _import('firmiana/admin/cvEdit')
      }
    ]
  }
  // 功能未健全
  // {
  //   path: '/messages',
  //   component: _import('firmiana/admin/index'),
  //   redirect: '/message/index',
  //   name: 'appMessages',
  //   meta: {icon: 'fa fa-envelope', title: 'Messages'},
  //   children: [
  //     // {
  //     //   path: 'globalSearch',
  //     //   name: 'appGlobalSearch',
  //     //   meta: {icon: 'fa fa-search', title: 'Global Search', noCache: false},
  //     //   component: _import('firmiana/admin/messages/globalsearch/index')
  //     // },
  //     {
  //       path: 'creatMessage',
  //       name: 'appCreatMessage',
  //       meta: {icon: 'fa fa-pencil', title: 'Creat Message', noCache: false},
  //       component: _import('firmiana/admin/messages/creatmessage')
  //     },
  //     {
  //       path: 'receiptMessage',
  //       name: 'appReceiptMessage',
  //       meta: {icon: 'fa fa-envelope-open', title: 'Receipt Message', noCache: false},
  //       component: _import('firmiana/admin/messages/receipt/index')
  //     },
  //     {
  //       path: 'sendMessage',
  //       name: 'appSendMessage',
  //       meta: {icon: 'fa fa-paper-plane', title: 'Send Message', noCache: false},
  //       component: _import('firmiana/admin/messages/send/index')
  //     },
  //     {
  //       path: 'Drafts',
  //       name: 'appDrafts',
  //       meta: {icon: 'fa fa-file', title: 'Drafts', noCache: false},
  //       component: _import('firmiana/admin/messages/drafts/index')
  //     },
  //     {
  //       path: 'systemMessage',
  //       name: 'appSystemMessage ',
  //       meta: {icon: 'fa fa-volume-up', title: 'System Message', noCache: false},
  //       component: _import('firmiana/admin/messages/system/index')
  //     },
  //     {
  //       path: 'receiptDetail',
  //       name: 'appReceiptDetail',
  //       // meta: {icon: 'fa fa-volume-up', title: 'System Message', noCache: false}
  //       component: _import('firmiana/admin/messages/receipt/detail'),
  //       hidden: true
  //     },
  //     {
  //       path: 'sendDetail',
  //       name: 'appSendDetail',
  //       // meta: {icon: 'fa fa-volume-up', title: 'System Message', noCache: false}
  //       component: _import('firmiana/admin/messages/send/detail'),
  //       hidden: true
  //     }
  //   ]
  // }
  // admin router end
]
export const projectRouterMap = [
  {
    path: '/project',
    name: 'Project',
    meta: {icon: 'fa fa-folder', title: 'Projects Management', noCache: false},
    component: Layout,
    redirect: '/project/index',
    hidden: false,
    children: [
      {
        path: 'index',
        name: 'appmetaPro',
        meta: {icon: 'fa fa-sitemap', title: 'Projects', noCache: false},
        component: _import('firmiana/project/list/project'),
        hidden: false
      },
      {
        path: 'createPro',
        name: 'appcreatePro',
        meta: {icon: '', hidden: true, title: 'Create Projects', noCache: false},
        component: _import('firmiana/project/create/project/createPro'),
        hidden: true
      },
      {
        path: 'modifyProject',
        name: 'appnewProjectModify',
        meta: {icon: '', hidden: true, title: 'Modify Projects', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/project/modifyPro'),
        hidden: true
      },
      {
        path: 'projectmembersedit',
        name: 'appProjectMembersEdit',
        hidden: true,
        meta: {icon: 'fa fa-list fa-fw', title: 'Project Members Edit', noCache: false},
        component: _import('firmiana/admin/project/rolesSet')
      },
      {
        path: 'checkExp',
        name: 'appnewCheckExpInProject',
        meta: {icon: '', hidden: true, title: 'Check Exp in One Project', noCache: false},
        component: _import('firmiana/project/create/project/experimentList'),
        hidden: true
      },
      {
        path: 'exp',
        name: 'appExpList',
        meta: {icon: 'fa fa-flask', title: 'Experiments', noCache: false},
        // component: _import('firmiana/project/mainRight/index'),
        component: _import('firmiana/project/list/experiment'),
        hidden: false
      },
      {
        path: 'createExp',
        name: 'appcreateExp',
        meta: {icon: 'fa fa-flask', title: 'Create Experiments', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/experiment/createExp1'),
        hidden: true
      },
      {
        path: 'draftExp',
        name: 'appnewExperimentDraft',
        meta: {icon: 'fa fa-flask', title: 'Draft Experiment', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/experiment/drafts/createExp'),
        hidden: true
      },
      {
        path: 'modifyExp',
        name: 'appnewExperimentModify',
        meta: {icon: 'fa fa-flask', title: 'Modify Experiment', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/experiment/modify/createExp'),
        hidden: true
      },
      {
        path: 'multiExp',
        name: 'appExpTemp',
        meta: {icon: '', title: 'Multiple Experiments', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/experiment/multiExp/createExp'),
        hidden: true
      },
      {
        path: 'createMS',
        name: 'appCreateMS',
        meta: {icon: '', title: 'Create MS', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/experiment/ms/index'),
        hidden: true
      },
      {
        path: 'modifyMS',
        name: 'appModifyMS',
        meta: {icon: '', title: 'Modify MS', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/experiment/ms/modifyMs'),
        hidden: true
      },
      {
        path: 'createDB',
        name: 'appCreateDB',
        meta: {icon: '', title: 'Create DB Search', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/DBSearch/DB'),
        hidden: true
      },
      {
        path: 'modifyDB',
        name: 'appModifyDB',
        meta: {icon: '', title: 'Modify DB Search', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/DBSearch/modifyDB'),
        hidden: true
      },
      {
        path: 'sam',
        name: 'appShowSam',
        meta: {icon: 'fa fa-hourglass-start', title: 'Samples', noCache: false},
        component: _import('firmiana/project/list/showSam'),
        hidden: false
      },
      {
        path: 'createSam',
        name: 'appnewSampleCreate',
        meta: {icon: '', title: 'Create Samples', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/samples/single/createSingleSam'),
        hidden: true
      },
      {
        path: 'modifySam',
        name: 'modifySingleSam',
        meta: {icon: '', title: 'Modify Sample', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/samples/modify/modifySingleSam'),
        hidden: true
      },
      {
        path: 'multiSam',
        name: 'multipSingleSams',
        meta: {icon: '', title: 'Template Sample', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/samples/multiSingleSample/multiSingleSam'),
        hidden: true
      },
      {
        path: 'rea',
        name: 'appReagentList',
        meta: {icon: 'fa fa-eyedropper', title: 'Reagents', noCache: false},
        component: _import('firmiana/project/list/reagent'),
        hidden: false
      },
      {
        path: 'createRea',
        name: 'appCreateRea',
        meta: {icon: '', title: 'Create Reagents', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/reagent/createRea'),
        hidden: true
      },
      {
        path: 'modifyRea',
        name: 'appnewReagentModify',
        meta: {icon: '', title: 'Modify Reagents', noCache: false, roles: ['User']},
        component: _import('firmiana/project/create/reagent/modifyRea'),
        hidden: true
      }
      // {
      //   path: 'uploadFile',
      //   name: 'appUploadFile',
      //   meta: {icon: 'fa fa-cloud-upload', title: 'Upload Files', noCache: false},
      //   component: _import('firmiana/project/upload/upload'),
      //   hidden: false
      // }
    ]
  },
  {
    path: '/processing',
    name: 'appProcessing',
    meta: {icon: 'fa fa-tasks', title: 'Data Processing', noCache: false, roles: ['User']},
    component: Layout,
    redirect: '/processing/index',
    hidden: false,
    children: [
      {
        path: 'index',
        name: 'Processing',
        meta: {icon: 'fa fa-tasks', title: 'Processing list', noCache: false, roles: ['User']},
        component: _import('firmiana/processing/index'),
        hidden: false
      },
      {
        path: 'WorkfLow',
        name: 'appWorkfLow',
        meta: {icon: 'fa fa-flask', title: 'workFlow', noCache: true, roles: ['User']},
        component: _import('firmiana/processing/processSteps'),
        hidden: true
      }
      // {
      //   path: 'modify',
      //   name: 'appProcessingList11',
      //   meta: {icon: 'fa fa-flask', title: 'Processing Modify Test', noCache: false, roles: ['User']},
      //   component: _import('firmiana/processing/children/childTwo'),
      //   hidden: false
      // }
    ]
  },
  {
    path: '/analysisI',
    name: 'appDatasetSelector',
    meta: {icon: 'fa fa-line-chart', title: 'Analysis I', noCache: false, roles: ['User']},
    component: Layout,
    hidden: false,
    children: [
      {
        path: 'datasetList',
        name: 'appDataSetList',
        meta: {icon: 'fa fa-flask', title: 'AnalysisI List', noCache: false, roles: ['User']},
        component: _import('firmiana/datasetSelector/index')
        // component: _import('firmiana/analysisI/newIndex1')
      },
      {
        path: 'compare',
        name: 'appCompare',
        meta: {icon: 'fa fa-flask', title: 'AnalysisI Compare', noCache: false, roles: ['User']},
        component: _import('firmiana/analysisI/compare'),
        // component: _import('firmiana/analysisI/analysisCompare/index'),
        hidden: true
      },

      {
        path: 'gene',
        name: 'appGene',
        meta: {icon: 'fa fa-flask', title: 'Gene List', noCache: false, roles: ['User']},
        component: _import('firmiana/ods/gene/index'),
        hidden: true
      },
      {
        path: 'peptide',
        name: 'appPeptide',
        meta: {icon: 'fa fa-flask', title: 'Peptide List', noCache: false, roles: ['User']},
        component: _import('firmiana/ods/peptide/index'),
        hidden: true
      },
      {
        path: 'protein',
        name: 'appProtein',
        meta: {icon: 'fa fa-flask', title: 'Protein List', noCache: false, roles: ['User']},
        component: _import('firmiana/ods/protein/index'),
        hidden: true
      },
      {
        path: 'proteinDetail',
        name: 'appProteinDetail',
        meta: {icon: 'fa fa-flask', title: 'protein detail', noCache: false, roles: ['User']},
        component: _import('firmiana/ods/proteinDetail/index'),
        hidden: true
      }
    ]
  },
  {
    path: '/tools',
    name: 'Tools',
    meta: {icon: 'fa fa-cogs', title: 'Tools', noCache: false, roles: ['User']},
    component: Layout,
    hidden: false,
    children: [
      {
        path: 'index',
        name: 'appTools',
        meta: {icon: 'fa fa-cogs', title: 'Tools', noCache: false, roles: ['User']},
        component: _import('firmiana/tools/index'),
        hidden: false
      }
    ]
  },
  {
    path: '/bigData',
    name: 'bigData',
    meta: {icon: 'fa fa-bar-chart', title: 'Analysis II', noCache: true, roles: ['User']},
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'index',
        name: 'appBigData',
        meta: {icon: 'fa fa-cogs', title: 'Big Data KNOWS', noCache: true, roles: ['User']},
        component: _import('firmiana/analysisII/index'),
        hidden: true
      },
      {
        path: 'search',
        name: 'appBigDataSearch',
        meta: {icon: 'fa fa-cogs', title: 'Global Search Result', noCache: true, roles: ['User']},
        component: _import('firmiana/analysisII/search'),
        hidden: true
      }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]
export const constantRouterMap = [
  {
    path: '/login',
    name: 'appLogin',
    meta: {icon: 'fa fa-home fa-fw', title: 'login', noCache: true, roles: ['User']},
    component: _import('firmiana/login/newLogin'),
    hidden: true
  },
  {
    path: '/reset',
    name: 'appReset',
    meta: {icon: 'fa fa-home fa-fw', title: 'reset', noCache: true, roles: ['User']},
    component: _import('firmiana/login/index'),
    hidden: true
  },
  {
    path: '/',
    name: 'apphome',
    meta: {icon: 'fa fa-home fa-fw', title: 'home', noCache: true, roles: ['User']},
    component: _import('firmiana/home/index'),
    hidden: true
  },
  {
    path: '/404',
    component: _import('firmiana/404'),
    hidden: true
  }
]
export default new Router({
  // model: 'history',
  scrollBehavior: () => {
    return {x: 0, y: 0}
  },
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js